import React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../../lib/utils'

const surfaceVariants = cva('rounded-card', {
  variants: {
    tone: {
      white: 'bg-white',
      inset:
        'bg-background-50 border border-[rgba(36,34,30,0.04)] rounded-card-sm',
      parchment: 'bg-background-300',
      warm: 'bg-background-500',
    },
  },
  defaultVariants: {
    tone: 'white',
  },
})

export interface SurfaceProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof surfaceVariants> {
  as?: React.ElementType
}

const Surface = React.forwardRef<HTMLDivElement, SurfaceProps>(
  ({ className, tone, as: Component = 'div', ...props }, ref) => {
    return (
      <Component
        ref={ref}
        className={cn(surfaceVariants({ tone }), className)}
        {...props}
      />
    )
  }
)

Surface.displayName = 'Surface'

export { Surface }
